export * from './states.controller';
import selectparts1 from './selectparts1.html';
import selectparts2 from './selectparts2.html';
import kitbuild1 from './kitbuild1.html';
import kitbuild2 from './kitbuild2.html';
import kitbuild3 from './kitbuild3.html';
import kitbuild4 from './kitbuild4.html';
import casing from './casing.html';
import confirm from './confirm.html';

export { selectparts1, selectparts2, kitbuild1, kitbuild2, kitbuild3, kitbuild4, casing, confirm }
